export default __webpack_public_path__ + "static/media/dog-and-cat.d2e6a013.svg";